/**
 * RoadDropdownState — renders the empty-state row inside the road Combobox
 * dropdown. Shows a loading message while the initial page is being fetched,
 * an error message when the request failed, or a "no results" message when the
 * query yields nothing (including out-of-scope workspaces, where the hook
 * returns empty and issues no request).
 */

import { Combobox, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import classes from '../RoadDisplayField.module.css';

interface RoadDropdownStateProps {
  /** Whether the initial page is currently loading. */
  isLoading: boolean;
  /** Whether the last request failed (distinct from a genuinely empty result). */
  isError: boolean;
}

export function RoadDropdownState({
  isLoading,
  isError,
}: RoadDropdownStateProps) {
  const { t } = useTranslation();

  function resolveMessage(): string {
    if (isLoading) return t('roads.loading');
    if (isError) return t('roads.error');
    return t('roads.noResults');
  }

  return (
    <Combobox.Empty className={classes.dropdownState}>
      <Text size="sm" c="dimmed">
        {resolveMessage()}
      </Text>
    </Combobox.Empty>
  );
}
